import React from 'react';
import { TbHandClick, TbUsersGroup } from 'react-icons/tb';

import { KPIStatCard } from '../KPIStatCard';

interface KPIStatsProps {
  kpiData: {
    clickCertificate: number;
    clickPhone: number;
    clickUberEats: number;
    clickJustEat: number;
    clickDeliveroo: number;
    clickGoogleMaps: number;
    clickLinkWebsite: number;
    clickAllReviews: number;
  };
}

export const KPIStats: React.FC<KPIStatsProps> = ({ kpiData }) => {
  return (
    <div className="grid md:grid-cols-2 gap-4 ">
      <KPIStatCard title="Engagement Utilisateur" Icon={TbUsersGroup}>
        <ul className="list-disc pl-5 text-gray-500 text-sm">
          <li>
            Certificats cliqués : <strong>{kpiData.clickCertificate}</strong>
          </li>
          <li>
            Appels effectués : <strong>{kpiData.clickPhone}</strong>
          </li>
          <li>
            Commentaires vus : <strong>{kpiData.clickAllReviews}</strong>
          </li>
          <li>
            Clics Google Maps : <strong>{kpiData.clickGoogleMaps}</strong>
          </li>
        </ul>
      </KPIStatCard>
      <KPIStatCard title="Clics Livraison" Icon={TbHandClick}>
        <ul className="list-disc pl-5 text-gray-500 text-sm">
          <li>
            Clics UberEats : <strong>{kpiData.clickUberEats}</strong>
          </li>
          <li>
            Clics JustEat : <strong>{kpiData.clickJustEat}</strong>
          </li>
          <li>
            Clics Deliveroo : <strong>{kpiData.clickDeliveroo}</strong>
          </li>
          <li>
            Visites du site web : <strong>{kpiData.clickLinkWebsite}</strong>
          </li>
        </ul>
      </KPIStatCard>
    </div>
  );
};
